import PubSub from 'pubsub-js';


let current = 0;
const $anchorMenuPoint = $('.anchorMenu__point');
const $anchorMenuLinkGroup = $('.anchorMenu__linkGroup');
const $anchorMenu = $('.anchorMenu__link', $anchorMenuLinkGroup);

const setPointY = () => {
    const n = $anchorMenuLinkGroup.attr('data-scene');
    const target = $(`.anchorMenu__link:eq(${n})`);
    const y = target.position().top;
    const offsetY = target.css('margin-top');
    const offsetCircleY = (parseInt(target.height()) - parseInt($anchorMenuPoint.height())) / 2
    $anchorMenuPoint.css('top', `calc(${y}px + ${offsetY} + ${offsetCircleY}px)`);
}

PubSub.subscribe('top.updateAnchorMenu', (_msg, data) => {
    $anchorMenu.eq(current).removeClass('-current');
    $anchorMenu.eq(data).addClass('-current');

    current = data;

    $anchorMenuLinkGroup.attr('data-scene', data);

    setPointY();
});

PubSub.subscribe('init', () => {
    $anchorMenu.eq(current).addClass('-current');

    $anchorMenu.each((index, element) => {
        $(element).on('click', () => {
            if (current === index) return;
            const targetId = $(element).data('id');
            PubSub.publish('top.updateBackground', targetId);
        });
    });
});

PubSub.subscribe('resize', () => {
    setPointY();
});